import _extends from '@babel/runtime/helpers/extends';
import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/taggedTemplateLiteralLoose';
import { css } from '@emotion/css';
import c from 'classnames';
import mergeWith from 'lodash/mergeWith';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var autocompletePopperStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  z-index: 1300;\n"])));
var selectOverrideStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  .MuiAutocomplete-endAdornment {\n    top: unset;\n    right: 1.2rem;\n    [dir='rtl'] & {\n      right: unset;\n      left: 1.2rem;\n    }\n\n    .MuiButton-root {\n      padding: 0;\n    }\n  }\n\n  &.MuiAutocomplete-hasPopupIcon .MuiOutlinedInput-root,\n  &.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root {\n    padding-inline-end: 3.2rem;\n  }\n\n  &.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root {\n    padding-inline-end: 6.4rem;\n  }\n\n  .MuiOutlinedInput-root.Mui-focused {\n    .MuiAutocomplete-clearIndicator {\n      visibility: visible;\n    }\n  }\n\n  @media (pointer: fine) {\n    &:hover .MuiAutocomplete-clearIndicator {\n      visibility: visible;\n    }\n  }\n\n  .MuiOutlinedInput-input {\n    width: 0;\n    min-width: 3rem;\n  }\n\n  .MuiOutlinedInput-adornedStart {\n    padding-inline-start: 1.2rem;\n  }\n"])));
var optionOverrideStyles = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  &.MuiAutocomplete-option[data-focus=\"true\"],\n  &.Mui-focused {\n    background-color: var(--bg-tertiary);\n  }\n\n  &.MuiAutocomplete-option[aria-disabled=\"true\"] {\n    pointer-events: none;\n  },\n"])));
var listBoxStyles = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  max-height: 40vh;\n"])));
var popperStyles = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  .MuiPaper-root:empty {\n    opacity: 0;\n  }\n"])));
var AUTOCOMPLETE_STATIC_CLASSES = {
  clearIndicator: 'MuiAutocomplete-clearIndicator',
  endAdornment: 'MuiAutocomplete-endAdornment',
  groupLabel: 'MuiAutocomplete-groupLabel',
  groupUl: 'MuiAutocomplete-groupUl',
  hasClearIcon: 'MuiAutocomplete-hasClearIcon',
  hasPopupIcon: 'MuiAutocomplete-hasPopupIcon',
  input: 'MuiAutocomplete-input',
  inputRoot: 'MuiAutocomplete-inputRoot',
  listbox: c('MuiAutocomplete-listbox list-none overflow-auto m-0', listBoxStyles),
  loading: 'MuiAutocomplete-loading',
  noOptions: 'MuiAutocomplete-noOptions flex items-center',
  option: 'MuiAutocomplete-option flex items-center cursor-pointer p-0',
  paper: 'MuiAutocomplete-paper',
  popper: c('MuiAutocomplete-popper', autocompletePopperStyles),
  popupIndicator: 'MuiAutocomplete-popupIndicator',
  popupIndicatorOpen: 'MuiAutocomplete-popupIndicatorOpen',
  root: 'MuiAutocomplete-root',
  tag: 'MuiAutocomplete-tag'
};
var iconSizeStyles = function iconSizeStyles(size) {
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  svg {\n    width: ", "rem;\n    height: ", "rem;\n  }\n"])), size, size);
};
var ICON_CLASSES_CONFIG = {
  large: iconSizeStyles(2.4),
  medium: iconSizeStyles(2)
};
var getDefaultClasses = function getDefaultClasses(size) {
  return {
    clearIndicator: c('invisible', ICON_CLASSES_CONFIG[size]),
    endAdornment: 'absolute',
    input: 'py-4 flex-1',
    inputRoot: 'w-full flex-wrap py-4',
    listbox: 'p-8',
    loading: 'py-14 px-16 body-short-02 text-text-secondary',
    noOptions: 'py-14 px-16 body-short-02 text-text-secondary',
    option: c('bg-bg-primary rounded-8 hover:bg-bg-tertiary', optionOverrideStyles),
    paper: 'rounded-8 shadow-01 border border-divider my-8',
    popper: popperStyles,
    popupIndicator: ICON_CLASSES_CONFIG[size],
    popupIndicatorOpen: 'transform rotate-180',
    root: selectOverrideStyles,
    tag: 'm-2 bg-bg-tertiary'
  };
};
var getAutocompleteClasses = function getAutocompleteClasses(size, classes) {
  var mergedClasses = _extends({}, getDefaultClasses(size), classes);
  return mergeWith({}, AUTOCOMPLETE_STATIC_CLASSES, mergedClasses, function (c1, c2) {
    return c(c1, c2);
  });
};

export { getAutocompleteClasses, optionOverrideStyles };
//# sourceMappingURL=styles.js.map
